/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Latency_TitleInputs */

const en_measure_latency_title = /** @type {(inputs: Measure_Latency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response time`)
};

const zh_hans1_measure_latency_title = /** @type {(inputs: Measure_Latency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应时间`)
};

const pt_br2_measure_latency_title = /** @type {(inputs: Measure_Latency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de resposta`)
};

const es_measure_latency_title = /** @type {(inputs: Measure_Latency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de respuesta`)
};

const fr_measure_latency_title = /** @type {(inputs: Measure_Latency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de réponse`)
};

const de_measure_latency_title = /** @type {(inputs: Measure_Latency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwortzeit`)
};

const ru_measure_latency_title = /** @type {(inputs: Measure_Latency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время ответа`)
};

const it_measure_latency_title = /** @type {(inputs: Measure_Latency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo di risposta`)
};

/**
* | output |
* | --- |
* | "Response time" |
*
* @param {Measure_Latency_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_title = /** @type {((inputs?: Measure_Latency_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_title(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_title(inputs)
	if (locale === "es") return es_measure_latency_title(inputs)
	if (locale === "fr") return fr_measure_latency_title(inputs)
	if (locale === "de") return de_measure_latency_title(inputs)
	if (locale === "ru") return ru_measure_latency_title(inputs)
	if (locale === "it") return it_measure_latency_title(inputs)
	return en_measure_latency_title(inputs)
});